import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';
import './styles.scss';
import './media.scss';

const typeNeedsArray = {
  'Passenger Vans': [
    [
      '15 - Recliner Sprinter w. Luggage',
      'https://www.sprinter-rentals.com/van-rental/mercedes-15-recliner-seater-van'
    ],
    ['15 - Seater Sprinter w. Luggage', 'https://www.sprinter-rentals.com/15-seater-sprinter'],
    [
      '15 - Recliner Transit w. Luggage',
      'https://www.sprinter-rentals.com/van-rental/united-states/san-diego-ca/15-seater/ford-transit-van/0001005'
    ],
    ['12 - Seater Sprinter XL, 5x5ft trunk', 'https://www.sprinter-rentals.com/van'],
    ['12 - Seater Sprinter, 3x5 ft trunk', 'https://www.sprinter-rentals.com/12-seater-sprinter'],
    ['4X4 Sprinter 12 Seater w. 4WD', 'https://www.sprinter-rentals.com/4x4-sprinter-van-4WD']
  ],
  'Cargo & Crew Vans': [
    [
      'Crew Cargo 144 Sprinter 5 seater',
      'https://www.sprinter-rentals.com/5-seater-crew-van-mercedes-benz-sprinter'
    ],
    ['XL Crew Cargo Sprinter 5 seater', 'https://www.sprinter-rentals.com/crew-cargo-sprinter'],
    ['XL Cargo Sprinter with 2 seats', 'https://www.sprinter-rentals.com/cargo-van'],
    [
      'Transit Crew Cargo 5 seater',
      'https://www.sprinter-rentals.com/van-rental/united-states/san-diego-ca/crew-cargo/ford-transit-van/0001001'
    ],
    ['Transit Cargo with 2 seats', 'https://www.sprinter-rentals.com/cargo-transit-van']
  ],
  'Executive & Business Vans': [
    ['Luxury Van Rentals Overview', 'https://www.sprinter-rentals.com/business-class-sprinter-van'],
    ['VIP 11-Seater w. trunk / couch', 'https://www.sprinter-rentals.com/11-seater-VIP-van'],
    [
      '9 big seats Ford Transit w. trunk',
      'https://www.sprinter-rentals.com/9-seater-business-class-sprinter'
    ],
    ['9 - Seater Luxury Van w. trunk', 'https://www.sprinter-rentals.com/transit-luxury-seats'],
    [
      '8 - Seater Metris Mini van w. trunk',
      'https://www.sprinter-rentals.com/8-passenger-metris-minivan'
    ]
  ],
  'Europe vans w. trunk': [
    [
      'Euro 9 - Seater XL Sprinter',
      'https://www.sprinter-rentals.com/van-rental/germany/9-seater/sprinter-van/de0002001'
    ],
    [
      'Euro 9 - Seater Large Sprinter',
      'https://www.sprinter-rentals.com/munich-sprinter-van-rental'
    ],
    [
      'Euro Luxury 9 Seater Van',
      'https://www.sprinter-rentals.com/van-rental/germany/stuttgart/9-seater-vip/mercedes-sprinter-van/0004001'
    ],
    [
      'Euro 8 - Seater V-Class Vklasse',
      'https://www.sprinter-rentals.com/8-passenger-metris-minivan'
    ]
  ]
};
const EuropeLocationArray = {
  Germany: [
    ['Berlin', 'https://www.sprinter-rentals.com/berlin-van-rental'],
    ['Frankfurt', 'https://www.sprinter-rentals.com/fra-location'],
    ['Hamburg', 'https://van.sprinter-rentals.com/?location=GER+-+Hamburg'],
    ['Munich', 'https://www.sprinter-rentals.com/munich-rent-a-large-van'],
    ['Stuttgart', 'https://van.sprinter-rentals.com/?location=GER+-+Stuttgart']
  ],
  Italy: [
    ['Florence', 'https://van.sprinter-rentals.com/?location=ITA+-+Florence'],
    ['Milan', 'https://van.sprinter-rentals.com/?location=ITA+-+Milan'],
    ['Venice', 'https://van.sprinter-rentals.com/?location=ITA+-+Venice']
  ],
  More: [
    ['IR, Dublin', 'https://van.sprinter-rentals.com/?location=IRL+-+Dublin'],
    ['AT, Salzburg', 'https://van.sprinter-rentals.com/?location=AT+-+Salzburg'],
    ['AT, Vienna Wien', 'https://van.sprinter-rentals.com/?location=AT+-+Vienna+Wien'],
    ['CH, Zurich', 'https://van.sprinter-rentals.com/?location=CH+-+Swiss+Zurich'],
    ['UK, London', ''],
    ['FR, Paris', 'https://van.sprinter-rentals.com/?location=FR+-+Paris'],
    ['FR, Nice', 'https://van.sprinter-rentals.com/?location=FR+-+Nice'],
    ['CZ, Prague', 'https://van.sprinter-rentals.com/?location=CZ+-+Prague']
  ]
};
const USALocationArray = {
  'USA West': [
    {
      California: [
        ['Los Angeles', 'https://www.sprinter-rentals.com/los-angeles-van-rentals'],
        ['Oakland', 'https://van.sprinter-rentals.com/?location=CA+-+Oakland+Int+Airport'],
        ['Riverside', 'https://van.sprinter-rentals.com/?location=CA+-+Riverside'],
        ['Sacramento', 'https://www.sprinter-rentals.com/rent-a-van-sacramento'],
        [
          'San Bernardino/Ont.',
          'https://www.sprinter-rentals.com/rent-a-van-ontario-san-bernardino'
        ],
        ['San Diego', 'https://www.sprinter-rentals.com/san-diego-van-rentals'],
        [
          'San Diego, El Cajon',
          'https://van.sprinter-rentals.com/?location=CA+-+San+Diego+East+%2F+El+Cajon'
        ],
        ['San Francisco', 'https://www.sprinter-rentals.com/san-francisco-van-rentals'],
        ['San Jose', 'https://www.sprinter-rentals.com/san-jose_silicon-valley'],
        [
          'San Ysidro, CBX, TJ',
          'https://van.sprinter-rentals.com/?location=CA+-+San+Diego+South+%7C+San+Ysidro+CBX'
        ],
        ['Santa Ana, OC', 'https://www.sprinter-rentals.com/orange-county-van-rentals']
      ]
    },
    { Oregon: [['Portland', 'https://www.sprinter-rentals.com/portland-van-rental-salem']] },
    { Seattle: [['Seattle', 'https://www.sprinter-rentals.com/seattle-vans']] }
  ],
  'USA Mid': [
    {
      Arizona: [
        ['Tucson', 'https://van.sprinter-rentals.com/?location=AZ+-+Tucson'],
        ['Phoenix', 'https://www.sprinter-rentals.com/phoenix-van-rentals']
      ]
    },
    { Nevada: [['Las Vegas', 'https://www.sprinter-rentals.com/las-vegas-van-rentals']] },
    { Illinois: [['Chicago', 'https://www.sprinter-rentals.com/chicago-van-rentals']] },
    {
      Texas: [
        ['Austin', 'https://www.sprinter-rentals.com/austin-san-antonio-rent-a-van'],
        ['Dallas', 'https://www.sprinter-rentals.com/dallas-fort-worth-airport-van-rentals'],
        ['Houston', 'https://www.sprinter-rentals.com/houston-rent-a-van']
      ]
    }
  ],
  'USA East': [
    {
      Florida: [
        ['Miami', 'https://www.sprinter-rentals.com/miami-rent-a-van'],
        ['Orlando', 'https://van.sprinter-rentals.com/?location=FL+-+Orlando'],
        ['Tampa', 'https://www.sprinter-rentals.com/tampa-rent-a-van']
      ]
    },
    { Georgia: [['Atlanta', 'https://www.sprinter-rentals.com/atlanta-van-rentals']] },
    {
      "Carolina's": [
        ['Charlotte', 'https://van.sprinter-rentals.com/?location=NC+-+Charlotte'],
        ['Raleigh, Durham', 'https://van.sprinter-rentals.com/?location=NC+-+Raleigh+%2F+Durham'],
        [
          'Spartanburg',
          'https://van.sprinter-rentals.com/?location=SC+-+Spartanburg+%2F+Charlotte+NC'
        ]
      ]
    },
    {
      'New Jersey': [
        ['Florham Park'],
        ['Newark DFW', 'https://www.sprinter-rentals.com/new-jersey-van-rentals']
      ]
    },
    { 'New York': [['New York JFK']] },
    { Virginia: [['Richmond', 'https://www.sprinter-rentals.com/richmond-van-rentals']] }
  ]
};
const AdditionalArray = {
  ['Manage Booking']: [
    ['My Booking', 'https://van.sprinter-rentals.com/client'],
    ['Help Chat', 'https://www.sprinter-rentals.com/help'],
    ['FAQ', 'https://www.sprinter-rentals.com/faq'],
    ['Quick Guide', 'https://www.sprinter-rentals.com/van-rental-made-easy'],
    ['Cancel', 'https://www.sprinter-rentals.com/cancellation']
  ],
  ['Rental Support']: [
    ['Van Dimensions', 'https://www.sprinter-rentals.com/mercedes-benz-sprinter-van-dimensions'],
    ['Wrapping a van', 'https://www.sprinter-rentals.com/sprinter-van-rentals-usa-wrap-you'],
    ['Van Rental Rates', 'https://www.sprinter-rentals.com/rates'],
    ['Contact us', 'https://www.sprinter-rentals.com/contact'],
    ['24h Road Side', 'https://www.sprinter-rentals.com/road-side-assistance']
  ],
  ['List Your Van']: [
    ['Learn More', 'https://www.sprinter-rentals.com/start-my-van-rental-business'],
    ['Passive income', 'https://www.sprinter-rentals.com/host-signup'],
    ['Apply now', 'https://www.sprinter-rentals.com/start-signup']
  ]
};
const endArray = {
  'List your van': 'https://www.sprinter-rentals.com/start-signup',
  Terms: 'https://www.sprinter-rentals.com/tos',
  'Privacy Policy': 'https://www.sprinter-rentals.com/privacy'
};
const socialMedia = [
  {
    icon: <YouTubeIcon />,
    link: 'https://www.youtube.com/@sprinterrentals'
  },
  {
    icon: <InstagramIcon />,
    link: 'https://www.instagram.com/sprinterrentals/'
  },
  {
    icon: <XIcon />,
    link: 'https://x.com/Sprinter_Rental'
  },
  {
    icon: <FacebookIcon />,
    link: 'https://www.facebook.com/SprinterVan/'
  }
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const __renderLink = ([text, link]: string[], index: number) => (
    <>
      {link ? (
        <a href={link} className='footer__section-category__item' key={index} target='_blank'>
          {text}
        </a>
      ) : (
        <div className='footer__section-category__item' key={index}>
          {text}
        </div>
      )}
    </>
  );

  const _renderSection = (array: any, type: string, isSubtitle?: boolean) =>
    Object.keys(array).map(sec => (
      <div
        className={`footer__section-category ${type === 'additional' && 'additional'}`}
        key={sec}
      >
        <div className='footer__section-category__title'>{sec}</div>
        {isSubtitle ? (
          <>
            {array[sec].map((el: any, i: number) => (
              <div key={i}>
                <div className='footer__section__subtitle'>{Object.keys(el)}</div>
                <div className='footer__section__list'>
                  {Object.values(el).map((el: any, index: number) => (
                    <>
                      {el.map(([text, link]: string[], index: number) =>
                        __renderLink([text, link], index)
                      )}
                    </>
                  ))}
                </div>
              </div>
            ))}
          </>
        ) : (
          <>
            {array[sec].map(([text, link]: string[], index: number) =>
              __renderLink([text, link], index)
            )}
          </>
        )}
      </div>
    ));

  return (
    <div className='footer__wrapper'>
      <div className='footer__section two-column'>
        <div className='footer__section-title'>
          <img src='/images/van-types.png' />
          <span>Van Types</span>
        </div>
        {_renderSection(typeNeedsArray, 'normal')}
        <div className='footer__section__quick-links'>
          <div className='footer__section-title'>
            <span>Quick Links</span>
          </div>
          <div className='footer__section__quick-links__container'>
            {_renderSection(AdditionalArray, 'normal')}
          </div>
        </div>
      </div>
      <div className='footer__section locations'>
        <div className='footer__section-title location'>
          <img src='/images/footer-location.png' />
          <span>Locations</span>
        </div>
        <div className='footer__section-title europe'>
          <img src='/images/footer-location.png' />
          <span>Europe</span>
        </div>
        {_renderSection(USALocationArray, 'normal', true)}
        <div>{_renderSection(EuropeLocationArray, 'normal')}</div>
      </div>
      <div className='footer__section-end'>
        <span>Copyright © 2009 - {currentYear} Sprinter Rentals, All rights reserved.</span>
        <div className='footer__section-end__links'>
          {socialMedia.map((el, i) => (
            <a href={el.link} target='_blank'>
              {el.icon}
            </a>
          ))}
        </div>
        <div className='footer__section-end__items'>
          {Object.keys(endArray).map(sec => (
            <a href={endArray[sec as keyof typeof endArray]} key={sec} target='_blank'>
              {sec}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
